export default "/_next/static/images/34241ffe785d2073e71468d32c424ccf.png";